export default {
  "hero.badge": "India's Top IT Company",
  "hero.title": "We Build",
  "hero.title.highlight": "World-Class Software",
  "hero.subtitle": "200+ engineers building enterprise software for Fortune 500 clients. AI-powered, cloud-native, future-ready digital solutions.",
  "hero.cta1": "Get Free Consultation",
  "hero.cta2": "Watch Showreel",
  "stats.projects": "Projects Delivered",
  "stats.clients": "Clients Served",
  "stats.countries": "Countries Covered",
  "stats.industries": "Industries Served",
  "stats.years": "Years of Experience",
  "stats.software": "Software Products",
  "stats.satisfaction": "Customer Satisfaction",
  "stats.tickets": "Support Tickets Resolved",
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.portfolio": "Portfolio",
  "nav.industries": "Industries",
  "nav.caseStudies": "Case Studies",
  "nav.blogs": "Blogs",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.careers": "Careers",
  "nav.calculators": "Calculators",
  "testimonials.title": "What Our",
  "testimonials.title.highlight": "Clients Say",
  "testimonials.subtitle": "Trusted by 500+ businesses across 12 countries",
  "map.title": "Global",
  "map.title.highlight": "Footprint",
  "map.subtitle": "Serving clients across 12+ countries worldwide",
  "cta.book": "Book Consultation",
  "cta.call": "Call Now",
  "cta.whatsapp": "WhatsApp",
  "cta.quote": "Get Quote",
  "cta.email": "Email Us",
  "cta.demo": "Book Demo",
  "search.placeholder": "Search services, blogs, portfolio...",
  "search.noResults": "No results found",
  "search.allResults": "View all results",
  "footer.newsletter": "Newsletter",
  "footer.newsletter.desc": "Weekly insights on tech, AI, and strategy.",
  "footer.subscribe": "Subscribe",
  "footer.copyright": "All rights reserved.",
  "footer.iso": "ISO 27001 Certified",
  "footer.gdpr": "GDPR Ready",
  "footer.cmmi": "CMMI Level 3",
  "lang.switch": "Switch Language",
  "lang.en": "English",
  "lang.hi": "हिन्दी",
}